module.exports = __webpack_public_path__ + "static/media/doc.4e688d0f.svg";